/**
 * @file: ProductAuthorType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ProductAuthorType {
  ServiceAgent = 'sa',
  Technicians = 'tech',
}

export const ProductAuthorTypeValueSet = new Set([
  ProductAuthorType.ServiceAgent,
  ProductAuthorType.Technicians,
]);
